import Overlays from './Overlays';

export default {
  __init__: [ 'overlays' ],
  overlays: [ 'type', Overlays ]
};